import { Box, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import SearchTextField from '../../../components/SearchTextField';
import { ModerationSearchType, ModerationType } from '../../../services/types';
import useStyles from './Search.styles';

interface IProps {
  query?: string;
  type?: ModerationSearchType;
  moderationType: ModerationType;
  onChange: (type: ModerationSearchType, query: string) => void;
}

const Search = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { moderationType, onChange } = props;

  const [type, setType] = useState<ModerationSearchType>(props.type || ModerationSearchType.UserId);
  const [validationMessage, setValidationMessage] = useState<string>();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (type: ModerationSearchType, query: string) => {
    if (type === ModerationSearchType.StoryId || type === ModerationSearchType.UserId) {
      const regex = /^\d+$/gm;

      if (query && !regex.test(query)) {
        setValidationMessage('ID should be numbers.');
        return;
      }
    }

    setValidationMessage(undefined);
    onChange(type, query);
  };

  useEffect(() => {
    setValidationMessage(undefined);
  }, [type]);

  useEffect(() => {
    if (!props.query || !props.type) {
      return;
    }

    setType(props.type);
  }, [props.query, props.type]);

  return (
    <Box className={classes.wrap}>
      <Select value={type} onChange={e => setType(String(e.target.value) as ModerationSearchType)} inputProps={{ role: 'searchDropdown' }}>
        <MenuItem value={ModerationSearchType.UserId}>User ID</MenuItem>
        {moderationType === ModerationType.Comments && <MenuItem value={ModerationSearchType.StoryId}>Story ID</MenuItem>}
        {moderationType === ModerationType.Comments && <MenuItem value={ModerationSearchType.SeasonId}>Season ID</MenuItem>}
        {moderationType === ModerationType.Comments && <MenuItem value={ModerationSearchType.CommentId}>Comment ID</MenuItem>}
        {moderationType === ModerationType.ProfileImages && <MenuItem value={ModerationSearchType.UserName}>User Name</MenuItem>}
        <MenuItem value={ModerationSearchType.DisplayName}>Display Name</MenuItem>
      </Select>
      <SearchTextField
        defaultValue={props.query}
        className={classes.textFieldWrap}
        placeholder="Search"
        error={!!validationMessage}
        helperText={validationMessage}
        onValueChange={(value: string) => {
          if (!value) {
            handleChange(type, '');
          }
        }}
        onValueSubmit={(value: string) => {
          handleChange(type, value);

          if (inputRef.current) {
            inputRef.current.blur();
          }
        }}
        onCancel={() => {
          handleChange(type, '');
        }}
        inputRef={inputRef}
      />
    </Box>
  );
};

export default Search;
